// frontend/shared-ui/src/components/Title.jsx
import React from "react";

export default function Title({
  level = 1,
  children,
  subtitle,
  className = "",
  ...rest
}) {
  const Tag = `h${level}`;
  return (
    <Tag className={`fh-title fh-title--h${level} ${className}`} {...rest}>
      {children}
      {subtitle && <span className="fh-title__sub">{subtitle}</span>}
    </Tag>
  );
}
